import React, { Component } from "react";
import ConnectUsModal from "../ContactUsModal";
import ContactUsForDevice from "../ContactUsForDevice/index";
import Feedback from "../Feedback";
import EnterpriseWeChat from "../EnterpriseWeChat";
import Cookies from "js-cookie";
import dclog from "../../common/utils/dclog";
import { Popover, Modal, Icon } from "@ezviz/ezd";

import "./FixedBar.less";
import Activity from "./Activity";

const toTop = () => {
  document.documentElement.scrollTop = 0;
  window.monitor && window.monitor.report({textKey: `website_fixbar`, text: `回到顶部`});
  
};
const handleScroll = () => {
  if (
    document.body.scrollTop > 0 ||
    document.documentElement.scrollTop > 0
  ) {
    document.getElementById("fixed-bar") &&
      (document.getElementById("fixed-bar").style.visibility = "visible");
  } else {
    document.getElementById("fixed-bar") &&
      (document.getElementById("fixed-bar").style.visibility = "hidden");
  }
  if(document.getElementById("AdvertiseFloat") && document.getElementById("AdvertiseFloat").style.visibility === "visible") {
    document.getElementById("fixed-bar").style.bottom = "354px"
  }else {
    document.getElementById("fixed-bar").style.bottom = "40px"
  }
};

// 点击跳转链接，需要进行登录条件判断
function LinkNeedLogin(props) {
  const username = Cookies.get("ASG_DisplayName");
  let returnUrl = (props.href || '')
  if(returnUrl.indexOf('http') < 0) {
    returnUrl = window.location.origin + returnUrl
  }
  function gotoLogin() {
    const loginUrl =
      "/auth?host=" +
      window.location.host +
      "&r=" +
      Math.random() +
      "&returnUrl=" + returnUrl ;
    window.location.href = loginUrl;
    window.monitor && window.monitor.report({textKey: `website_fixbar_${props.ptype}`, text: `${props.title}_立即登录`});
  }
  if (!username) {
    return (
      <Popover
        placement="top"
        content={
          <div>
            <Icon
              type="info-filled"
              style={{ color: "#FAAD14", fontSize: 14, marginRight: 8 }}
            />
            请登录账号,让我们为您提供更好的服务
            <a
              onClick={gotoLogin}
              className="fixed-bar-worklist-a"
            >
              立即登录
            </a>
          </div>
        }
        arrowPointAtCenter
        overlayClassName="fixed-bar-worklist"
      >
        <a>
          <div className="item-title">{props.children}</div>
        </a>
      </Popover>
    );
  }
  return (
    <a href={returnUrl} target={props.target || '_blank'} textkey={`website_fixbar_${props.ptype}`}>
      <div className="item-title">{props.children}</div>
    </a>
  );
}

class FixedBar extends Component {
  constructor() {
    super();
    this.state = {
      visible: false,
      visible1: false,
      visible2: false,
      visible3: false,
      popVisible: false,
    };
    this.connectModal = React.createRef();
  }
  componentDidMount() {
    window.addEventListener('scroll', handleScroll)
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', handleScroll, false);
  }
  onClose = () => {
    this.setState({
      visible: false,
    });
  };
  showPop = () => {
    const { visible } = this.state;
    this.setState({
      visible: !visible,
    });
  };

  popoverContent = (ptype) => {

    const { data = [] } = this.props;
    const contentItem = data.map((item) => {
      let contentItemDom = (
        <div className="contactus-item" onClick={() => {
          this.setState({
            visible1: false,
            visible2: false,
            visible3: false,
          });
        }}>
          {item.leftIcon && 
            <div className="contactus-item-icon contactus-item-icon-left">
              <img className="contactus-item-icon-default" src={item.leftIcon} />
              <img className="contactus-item-icon-hover" src={item.leftHoverIcon} />
            </div>
          }
          <div className="contactus-item-main">
            <div className="item-title">{item.title}</div>
            {item.content &&
              item.content.length > 0 &&
              item.content.map((_item) => {
                return <div className="item-tips">{_item}</div>;
              })
            }
          </div>
          {item.rightIcon && 
            <div className="contactus-item-icon contactus-item-icon-right">
              <img className="contactus-item-icon-default" src={item.rightIcon} />
              <img className="contactus-item-icon-hover" src={item.rightHoverIcon} />
            </div>
          }
        </div>
      )
      let content;

      
      if(ptype === item.ptype) {
        switch (item.contactType) {
          // 弹窗,填写设备信息
          case "forDevice":
            content = (
              <ContactUsForDevice
                simpleDescription={item.simpleDescription}
                width={480}
                height={670}
                btnType={2}
                ptype={item.ptype}
                title={item.title}
                parentNode={()=>document.getElementsByClassName('cn-fixed-bar-wrap')[0]}
              >
                {contentItemDom}
              </ContactUsForDevice>
            );
            break;
          // 点击跳转到链接
          case "link":
            content = (
              <a
                target={item.target|| '_blank'}
                textkey={`website_fixbar_${item.ptype}`}
                href={item.href}
              >
                {contentItemDom}
              </a>
            );
            break;
          // 点击跳转到链接，需要登录
          case "linkNeedLogin":
            content = (
              <LinkNeedLogin 
                href={item.href} 
                target={item.target}
                ptype={item.ptype}
                title={item.title}
              >
                {contentItemDom}
              </LinkNeedLogin>
            );
            break;
          // 弹窗，弹出微信客服二位码
          case "weChat":
            content = ptype === 2 ? <Activity /> :   <EnterpriseWeChat
            ptype={item.ptype}
            title={item.weChatTitle || "联系我们"}
            // 兼容旧版，增加埋点配置
            textKeyTitle={item.title || item.weChatTitle}
            weChatImg={item.weChatImg || "https://resource.eziot.com/group1/M00/00/8F/CtwQE2MHDr-AOVTTAAAGDyC5ekQ047.png"}
            weChatDesc={item.weChatDesc || "微信扫一扫联系我们"}
            parentNode={()=>document.getElementsByClassName('cn-fixed-bar-wrap')[0]}
          >
            {contentItemDom}
          </EnterpriseWeChat>
            break;

            // 弹窗,用户反馈
          case "feedback":
            content = (
              <Feedback
                feedbackTitle = {item.feedbackTitle}
                badReason={item.badReason || []}
                goodReason={item.goodReason || []}
                ptype={item.ptype}
                title={item.title}
                parentNode={()=>document.getElementsByClassName('cn-fixed-bar-wrap')[0]}
              >
                {contentItemDom}
              </Feedback>
            );
            break;
          
          // 默认弹窗。填写联系方式
          default:
            content = (
              <ConnectUsModal
                simpleDescription={item.simpleDescription}
                width={458}
                height={648}
                ptype={item.ptype}
                title={item.title}
                parentNode={()=>document.getElementsByClassName('cn-fixed-bar-wrap')[0]}
              >
                {contentItemDom}
              </ConnectUsModal>
            );
            break;
        }
        return content;
      }
    });
    return <div className="contactus-container">{contentItem}</div>;
  };



  render() {
    return (
      <div className="cn-fixed-bar">
        <div className="cn-fixed-bar-wrap"></div>
        <div className="cn-fixed-bar-container">
          <Popover
            visible={this.state.visible1}
            onVisibleChange={(visible) => {
              this.setState({ visible1: visible });
            }}
            getPopupContainer={false}
            content={this.popoverContent(1)}
            placement="left"
            overlayClassName="fixed-bar-popover"
          >
            <div
              className="cn-fixed-bar-item cn-fixed-bar-item-blue">
              <div className="fixedBar-contactus">
                联系我们
              </div>
            </div>
          </Popover>
          <div
            className="cn-fixed-bar-item"
            style={{ margin: "15px 0" }}
          >
            <Popover
              content={this.popoverContent(2)}
              visible={this.state.visible2}
              onVisibleChange={(visible) => {
                this.setState({ visible2: visible });
              }}
              placement="left"
              overlayClassName="fixed-bar-popover"
            >
              <div className="fixedBar-icon2 fixedBar-icon2-active">活动</div>
            </Popover>
            <Popover
              content={this.popoverContent(3)}
              visible={this.state.visible3}
              onVisibleChange={(visible) => {
                this.setState({ visible3: visible });
              }}
              placement="left"
              overlayClassName="fixed-bar-popover"
            >
              <div className="fixedBar-icon2 fixedBar-icon2-feedback">反馈</div>
            </Popover> 
          </div>
            
          <div  id="fixed-bar" style={{ visibility: "hidden" }} className="cn-fixed-bar-totop" onClick={toTop}>
            <div className="fixedBar-icon3"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default FixedBar;
